export const mutations = {
  updateProjectId(state, projectId) {
    state.projectId = projectId;
  },
  updateProjectProperties(state, projectProperties) {
    state.projectProperties = {
      ...state.projectProperties,
      ...projectProperties,
    };
  },
  updateConfiguration(state, configuration) {
    state.configuration = {
      ...state.configuration,
      ...configuration,
    };
  },
  updatePous(state, pous) {
    state.pous = pous;
  },
  updateDataTypes(state, dataTypes) {
    state.dataTypes = dataTypes;
  },

  updateAddItem(state, addItem) {
    state.addItem = addItem;
  },

  updateShowLoading(state, showLoading) {
    state.showLoading = showLoading;
  },
};
